import { UserCollection } from '/@/modules/user/models/UserCollection';
import { estateAssignableUsers, estateAdministrators, professionalUsers } from '@/modules/user/store/user.state';
import { User } from '@/modules/user/models/User';

/**
 * @deprecated
 */
export function setEstateAssignableUsers(users: User[]): void {
  estateAssignableUsers.value = UserCollection.mapModel(users);
}

/**
 * @deprecated
 */
export function setEstateAdministrators(users: User[]): void {
  estateAdministrators.value = users ?? [];
}

/**
 * @deprecated
 */
export function setProfessionalUsers(users: User[]): void {
  professionalUsers.value = users ?? [];
}

